const AesShipmentReasonApiUrls = {
  GET: `${process.env.REACT_APP_USER_AES_URL}/aes/shipment/response/get`,
  GET_AUDIT_LOGS: `${process.env.REACT_APP_CNG_ADMIN_ORIGIN_URL}/cng-admin/audit-header/get`,
};

export default AesShipmentReasonApiUrls
